import qs from "qs";
import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

type Params = Record<string, unknown>;

const cutEmptyParams = (
  oldState: Record<string, unknown>,
  excludedValues: string[],
) => {
  return Object.keys(oldState).reduce<Record<string, unknown>>((acc, key) => {
    if (!excludedValues.includes(key)) {
      acc[key] = oldState[key];
    }
    return acc;
  }, {});
};

export const useURLParamsSetter = (useReplace = false) => {
  const history = useHistory();
  const location = useLocation();

  return (params?: Params) => {
    if (typeof params === "undefined") {
      history[useReplace ? "replace" : "push"]({ search: "" });
      return;
    }

    const oldState = qs.parse(location.search.slice(1));

    const filteredByValueKeysArray = Object.keys(params).reduce(
      (acc, key) => {
        const value = params[key];
        if (value !== undefined && value !== null && value !== "") {
          acc.included.push(key);
        } else {
          acc.excluded.push(key);
        }
        return acc;
      },
      { included: [] as string[], excluded: [] as string[] },
    );

    const toObj = filteredByValueKeysArray.included.reduce(
      (acc, key) => ({ ...acc, [key]: params[key] }),
      {},
    );

    const paramStr = qs.stringify({
      ...cutEmptyParams(oldState, filteredByValueKeysArray.excluded),
      ...toObj,
    });

    history[useReplace ? "replace" : "push"]({ search: paramStr });
  };
};

export const useURLParamsGetter = <ReturnType>() => {
  const location = useLocation();

  return useMemo(
    () =>
      qs.parse(decodeURI(location.search.slice(1))) as unknown as ReturnType,
    [location.search],
  );
};
